import { render, staticRenderFns } from "./UploadReferralAdditionalRecords.vue?vue&type=template&id=c74198d2&scoped=true"
import script from "./UploadReferralAdditionalRecords.vue?vue&type=script&lang=js"
export * from "./UploadReferralAdditionalRecords.vue?vue&type=script&lang=js"
import style0 from "./UploadReferralAdditionalRecords.vue?vue&type=style&index=0&id=c74198d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74198d2",
  null
  
)

export default component.exports